class Footnotes {
  constructor() {
    this.footnotes = document.querySelectorAll('.ns-style-footnote');
    this.footnotes = Array.prototype.slice.call(this.footnotes);
    if(this.footnotes){
      this.checkFootnotes();
    }
  }

  checkFootnotes(){
    if (this.footnotes) {
      if(this.footnotes.forEach(footnote => {
        if(footnote.children.length > 2) {
          this.wrapFootnotes(footnote);
        }
      }));
    }
  }

  wrapFootnotes(footnote){
    const children = Array.from(footnote.children);
    const wrapper = document.createElement('span');
    wrapper.classList.add('ns-footnote-wrapper');

    children.forEach(child => {
      if (!child.classList.contains('ns-footnote-key')) {
        wrapper.appendChild(child);
      }
    });

    footnote.appendChild(wrapper);
  }
}

export default Footnotes;
